import { Box, Stack } from '@mui/material';
import React from 'react'
import Images from '../../../utils/Images';

const AdvantageSection = () => {

    return (
        <section className="advantageSection">
            <img className="mobileCafeImage" alt="mobileCafeImage" src={Images.cafeMobile} />
            <h1 className="advantageTitle">XPANSE <span className="advantageSpan">Advantage</span></h1>
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <p className="advantagePoint">Not just a cafe. A tech-first movement redefining India's coffee game. Here's what makes Xpanse unlike anything else out there.</p>
            </Box>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <p className="advantagePoint">Not just a cafe. A tech-first movement redefining India's coffee game.</p>
                <p className="advantagePoint">Here's what makes Xpanse unlike anything else out there.</p>
            </Box>

            <Box className="advantageCoffeeBox">
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={{ xs: 4, md: 0 }}
                >
                    <Box
                        sx={{
                            order: { xs: 0, md: 1 }, // image on top in small, last in large
                            width: { xs: '100%', md: '50%' },
                            textAlign: 'center',
                        }}
                    >
                        <img className="advantageCoffeImage" alt="advantageCoffeImage" src={Images.a1} style={{ width: '100%', maxWidth: '400px' }} />
                    </Box>

                    <Box
                        sx={{
                            order: { xs: 1, md: 0 },
                            width: { xs: '100%', md: '50%' },
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <h3 className="advantageCoffeeTitle" style={{}}>App-<i>Only</i> Model</h3>
                        <p className="advantageCoffeePara"><i>Smarter ordering. Faster service. Happier customers.</i></p>
                        <Box className="advantageCoffeeListBox" paddingTop={2}>
                            {[
                                { img: Images.a1_1, text: 'App-based ordering = no queues, no delays' },
                                { img: Images.a1_2, text: 'Built-in loyalty = better retention' },
                                { img: Images.a1_3, text: '100% cashless = full transparency' },
                                { img: Images.a1_4, text: 'Real-time data = sharper marketing, better ops' }
                            ].map((item, index) => (
                                <Stack direction="row" alignItems="center" key={index} sx={{ marginBottom: 1 }}>
                                    <img src={item.img} alt="advantageCoffeImagePoint" style={{ height: '100%', paddingRight: '1.5vh' }} />
                                    <p className="advantageCoffeeList">{item.text}</p>
                                </Stack>
                            ))}
                        </Box>
                    </Box>
                </Stack>

            </Box>

            <Box className="advantageCoffeeBox">
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={{ xs: 4, md: 0 }}
                >
                    <Box
                        sx={{
                            order: { xs: 0, md: 0 },
                            width: { xs: '100%', md: '50%' },
                            textAlign: 'center',
                        }}
                    >
                        <img className="advantageCoffeImage" alt="advantageCoffeImage" src={Images.a2} style={{ width: '100%', maxWidth: '400px' }} />
                    </Box>
                    <Box
                        sx={{
                            order: { xs: 1, md: 1 },
                            width: { xs: '100%', md: '50%' },
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <h3 className="advantageCoffeeTitle">AI-Graded Beans</h3>
                        <p className="advantageCoffeePara"><i>Tech that tastes the difference.</i></p>
                        <Box className="advantageCoffeeListBox" paddingTop={2}>
                            {[
                                { img: Images.a2_1, text: 'AI -powered bean selection for consistent quality' },
                                { img: Images.a2_2, text: 'Better flavor profiles, cup after cup' },
                                { img: Images.a2_3, text: 'No manual errors in grading or sourcing' },
                                { img: Images.a2_4, text: 'Standardized quality across every outlet' }
                            ].map((item, index) => (
                                <Stack direction="row" alignItems="center" key={index} sx={{ marginBottom: 1 }}>
                                    <img src={item.img} alt="advantageCoffeImagePoint" style={{ height: '100%', paddingRight: '1.5vh' }} />
                                    <p className="advantageCoffeeList">{item.text}</p>
                                </Stack>
                            ))}
                        </Box>
                    </Box>
                </Stack>
            </Box>

            <Box className="advantageCoffeeBox">
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={{ xs: 4, md: 0 }}
                >
                    <Box
                        sx={{
                            order: { xs: 0, md: 1 },
                            width: { xs: '100%', md: '50%' },
                            textAlign: 'center',
                        }}
                    >
                        <img className="advantageCoffeImage" alt="advantageCoffeImage" src={Images.a3} style={{ width: '100%', maxWidth: '400px' }} />
                    </Box>
                    <Box
                        sx={{
                            order: { xs: 1, md: 0 },
                            width: { xs: '100%', md: '50%' },
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <h3 className="advantageCoffeeTitle">R&D by Team24</h3>
                        <p className="advantageCoffeePara"><i>Innovation is part of the business model.</i></p>
                        <Box className="advantageCoffeeListBox" paddingTop={2}>
                            {[
                                { img: Images.a3_1, text: 'New drinks, limited editions and seasonal menus' },
                                { img: Images.a3_2, text: 'Constant product development based on trends' },
                                { img: Images.a3_3, text: 'Backed by a team that\'s built winning F&B brands' },
                                { img: Images.a3_4, text: 'Faster rollout of innovations across all the outlets' }
                            ].map((item, index) => (
                                <Stack direction="row" alignItems="center" key={index} sx={{ marginBottom: 1 }}>
                                    <img src={item.img} alt="advantageCoffeImagePoint" style={{ height: '100%', paddingRight: '1.5vh' }} />
                                    <p className="advantageCoffeeList">{item.text}</p>
                                </Stack>
                            ))}
                        </Box>
                    </Box>
                </Stack>
            </Box>

            <Box className="advantageCoffeeBox">
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={{ xs: 4, md: 0 }}
                >
                    <Box
                        sx={{
                            order: { xs: 0, md: 0 },
                            width: { xs: '100%', md: '50%' },
                            textAlign: 'center',
                        }}
                    >
                        <img className="advantageCoffeImage" alt="advantageCoffeImage" src={Images.a4} style={{ width: '100%', maxWidth: '400px' }} />
                    </Box>
                    <Box
                        sx={{
                            order: { xs: 1, md: 1 },
                            width: { xs: '100%', md: '50%' },
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <h3 className="advantageCoffeeTitle">FOCO Model</h3>
                        <p className="advantageCoffeePara"><i>Franchise-Owned. Company-Operated. Low-Risk.</i></p>
                        <Box className="advantageCoffeeListBox" paddingTop={2}>
                            {[
                                { img: Images.a4_1, text: 'We run the ops, you focus on growth' },
                                { img: Images.a4_2, text: 'No staff or supplier management for you' },
                                { img: Images.a4_3, text: 'Consistent service and experience at every outlet' },
                                { img: Images.a4_4, text: 'Proven, scalable and investor-friendly model' }
                            ].map((item, index) => (
                                <Stack direction="row" alignItems="center" key={index} sx={{ marginBottom: 1 }}>
                                    <img src={item.img} alt="advantageCoffeImagePoint" style={{ height: '100%', paddingRight: '1.5vh' }} />
                                    <p className="advantageCoffeeList">{item.text}</p>
                                </Stack>
                            ))}
                        </Box>
                    </Box>
                </Stack>
            </Box>

        </section>
    )
}

export default AdvantageSection;
